import { RESET_OLD_SESSION_STATUS, SET_OLD_SESSION_STATUS } from "../Actions/Constants";

  const initialState = {
    isThisOldSession: false
  };
  
  // Reducer
  export function oldSessionReducer(state = initialState, action = {}) {
    switch (action.type) {
      case SET_OLD_SESSION_STATUS:
        return {
          ...state,
          isThisOldSession: action.payload   // true / false
        };
  
      case RESET_OLD_SESSION_STATUS:
        return initialState;
  
      default:
        return state;
    }
  }